export default "__VITE_ASSET__BgaOIAjF__"